function animateCounters(duration = 2000) {
  const counters = document.querySelectorAll(".counter");

  counters.forEach((counter) => {
    const targetValue = parseInt(counter.textContent, 10);
    if (isNaN(targetValue)) return;

    let startTimestamp = null;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;

      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const currentValue = Math.floor(progress * targetValue);

      counter.textContent = currentValue;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        counter.textContent = targetValue; // Ensure exact value
      }
    };

    requestAnimationFrame(step);
  });
}

// Set up Intersection Observer
const observer = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateCounters(); // Trigger animation
        observer.unobserve(entry.target); // Stop observing after first trigger
      }
    });
  },
  {
    threshold: 0.5, // Adjust depending on when you want to trigger (e.g., 50% visible)
  },
);

// Start observing the parent container
const countersContainer = document.querySelector(".counters");

if (countersContainer) {
  observer.observe(countersContainer);
}
